import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[7]}px;
  padding: ${({ theme }) => `${theme.spacing[5]}px ${theme.spacing[4]}px`};
  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[4]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[4]}px;
      color: ${theme.colors.neutral.neutral_alpha[12]};
    `;
  }};
`;

export const ContainerTop = styled.div`
  display: flex;
  width: 100%;

  ${({ theme }) => {
    return css`
      flex-direction: row;
      gap: ${theme.spacing[9]}px;
      justify-content: space-between;
    `;
  }}
`;

export const ContainerInfos = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: ${({ theme }) => theme.tamanhoCartaz.height['grande']}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
  justify-content: space-around;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const BackgroundWrapper = styled.div`
  width: 100%;
  z-index: -1;
  overflow: hidden;
  position: relative;

  margin-bottom: -200px;
  @media (max-width: 1077px) {
    margin-bottom: -300px;
  }

  height: 220px;
  @media (max-width: 1077px) {
    height: 300px;
  }
`;

export const Grandiente = styled.div`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(17, 17, 17, 0.1),
    rgba(17, 17, 17, 1)
  );
`;

export const BlurredBackground = styled.div`
  width: 100%;

  img {
    filter: blur(21.25px) brightness(0.75);
  }
`;

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => theme.spacing[4]}px;
  border-radius: ${({ theme }) => theme.radius[2]}px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral[2]};
  margin-top: ${({ theme }) => theme.spacing[4]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const TextInput = styled.textarea`
  min-height: 44px;
  width: 100%;
  resize: vertical;
  height: 100px;
  resize: none;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight[3]};
      line-height: ${theme.typography.font.line_height[3]}px;
      color: ${theme.colors.neutral.neutral[12]};
    `;
  }}
`;
